<template>
  <div class="sidebar-logo-container pointer" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">

      <div class="userInfo flex pointer" @click="$emit('userShowModal')">
        <img v-if="userInfo.avatar&&userInfo.avatar!=''" :src="userInfo.avatar" alt="">
        <img v-else src="../../../static/daoshi.png" alt="">
        <div class="userName ">
          <div class="flex">
            <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; max-width:120px;">{{ userInfo.name }}</div>
            <i class="el-icon-arrow-right" style="margin-left: 3px;" />
          </div>
          <div class="grade" style="transform: scale(0.9);margin-left: -3px;">Lv{{ chooseItem.leave }}讲师</div>
        </div>
      </div>

      <!-- <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/user">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ title }} </h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/user">
        <img v-if="logo" :src="logo" class="sidebar-logo">
        <h1 class="sidebar-title">{{ title }} </h1>
      </router-link> -->
    </transition>
  </div>
</template>

<script>
import { accAdd, accDiv, accMul, accSub } from '@/utils'
import { getLocalStorage } from '@/utils/auth'

export default {
  name: 'SidebarLogo',
  props: {
    userInfo: {
      type: Object,
      required: true
    },
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      chooseItem: '', // 当前等级
      title: '知视猫',
      logo: 'https://file.jinglinshe.com/zhishimao_logo2.png'
    }
  },
  mounted() {
    this.getFund()
  },
  methods: {
    // 获取用户资金信息
    getFund() {
      this.$store.dispatch('zsm-fund/getFundUser', this.userInfo.mobile).then((res) => {
        if (res.result == 'true') {
          this.getSettingDict(res.data)
        }
      })

      /* this.$store.dispatch('zsm-fund/getFund', this.userInfo.id).then((res) => {
        if (res.result == 'true') {
          this.getSettingDict(res.data)
        }
      })*/
    },
    // 获取字典内容
    getSettingDict(fundsInfo) {
      this.$store.dispatch('zsm-dict/settingDict', 'zsm_web_user_grade_dict').then(info => { // 	知视猫--前端首页讲师等级权益
        this.computeExperience(info, fundsInfo)
      }
      )
    },
    // 计算经验值
    computeExperience(info, fundsInfo) {
      var income = 0
      var percentage = 0
      this.percentage = 0

      if (fundsInfo.income && fundsInfo.incomeMock) {
        income = accAdd(fundsInfo.income, fundsInfo.incomeMock)
      } else if (fundsInfo.income) {
        income = fundsInfo.income
      } else if (fundsInfo.incomeMock) {
        income = fundsInfo.incomeMock
      }

      /* if (fundsInfo.income && fundsInfo.doudianFee) {
        income = accAdd(fundsInfo.income, fundsInfo.doudianFee)
      } else if (fundsInfo.income) {
        income = fundsInfo.income
      } else if (fundsInfo.doudianFee) {
        income = fundsInfo.doudianFee
      }*/

      /* if (fundsInfo.income) {
        income = fundsInfo.income
      }*/
      info.map((item, index) => {
        if (income >= item.cssStyle && income < item.cssClass) {
          this.chooseItem = item
          this.chooseItem.leave = index + 1
        } else if (income > 1000000) {
          this.chooseItem = info[info.length-1]
          this.chooseItem.leave='5'

          percentage = 100
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
  .sidebarLogoFade-enter-active {
    transition: opacity 1.5s;
  }

  .sidebarLogoFade-enter,
  .sidebarLogoFade-leave-to {
    opacity: 0;
  }

  .userInfo {
    padding-top: 15px;
    height: 95px;

    .flex {
      align-items: center;
    }

    padding: 16px 20px;

    .grade {
      color: rgba(42, 106, 255, 1);
      font-size: 12px;
      line-height: 1;
    }

    .userName {
      // margin-top: 11px;
      line-height: 26px;
      font-size: 12px;
      font-weight: 500;
      color: #161823;

      i {
        font-size: 12px;
        color: #B9B7B7;
      }
    }

    img {
      margin-right: 8px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }

    .grade {
      font-size: 12px;
      width: 60px;
      height: 22px;
      line-height: 22px;
      border-radius: 3px;
      background-color: rgba(238, 245, 252, 1);
    }
  }

  .sidebar-logo-container {
    position: relative;
    width: 100%;
    height: 100px;
    background: #fff;
    text-align: center;
    overflow: hidden;
    padding-top: 0px;

    & .sidebar-logo-link {
      height: 100%;
      width: 100%;

      & .sidebar-logo {
        width: 50px;
        height: 50px;
        margin-left: -67px;
        vertical-align: middle;

      }

      & .sidebar-title {
        display: inline-block;
        margin: 0;
        color: #fff;
        font-weight: 600;
        line-height: 50px;
        font-size: 14px;
        font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
        vertical-align: middle;
      }
    }

    &.collapse {
      .sidebar-logo {
        margin-right: 0px;
      }
    }
  }
</style>
